import { BehaviorSubject, throwError as observableThrowError, } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { EventEmitter } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import "rxjs/Rx";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Resource } from "../models/resource/resource";
import { StandardsInformation } from "../models/resource/standards";
import { TextDisplayModalComponent } from "../shared-components/modals/text-display-modal/text-display-modal.component";
import { LmApiService } from "./lm-api.service";
import { LocalizationService } from "./localization.service";
import { URSService } from "./urs.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./lm-api.service";
import * as i3 from "./localization.service";
import * as i4 from "@angular/router";
import * as i5 from "./urs.service";
import * as i6 from "@ng-bootstrap/ng-bootstrap";
var ResourceService = /** @class */ (function () {
    function ResourceService(http, lmApi, localizationService, router, ursService, modalService) {
        this.http = http;
        this.lmApi = lmApi;
        this.localizationService = localizationService;
        this.router = router;
        this.ursService = ursService;
        this.modalService = modalService;
        this.initialData = new Resource();
        this.initialStandardsInfo = new StandardsInformation();
        this.resourceResponse = new BehaviorSubject(this.initialData);
        this.standardsResponse = new BehaviorSubject(this.initialStandardsInfo);
        this.goToSupportMaterials = new EventEmitter();
        this.subscriptions = [];
    }
    ResourceService.prototype.resetData = function () {
        // Reset, so we don't display obsolete data
        this.resourceResponse.next(this.initialData);
        this.standardsResponse.next(this.initialStandardsInfo);
    };
    ResourceService.prototype.getResource = function (resourceCode) {
        var _this = this;
        this.resetData();
        this.cancelSubscriptions();
        var resourceURL = "/api/v2/resource/" + resourceCode + "/";
        this.subscriptions.push(this.lmApi
            .getWithCookiesInParams(resourceURL, [
            "user_content_permission",
        ])
            .pipe(catchError(function (error) { return observableThrowError(error); }), map(function (response) { return Resource.fromData(response); }))
            .subscribe(function (resource) {
            // todo: if invalid, raise 404
            _this.resourceResponse.next(resource);
            _this.updateUrsRestrictions(resource);
            if (resource.hasStandards) {
                _this.setStandardsInformation(resource.resourceCode);
            }
        }));
    };
    ResourceService.prototype.updateUrsRestrictions = function (resource) {
        var _this = this;
        resource.assets.forEach(function (asset) {
            return asset.medias.forEach(function (media) {
                return media.evaluateURSRestriction(_this.ursService);
            });
        });
    };
    ResourceService.prototype.incrementViewCount = function (resourceCode) {
        this.lmApi
            .get("/resource/view-count/" + resourceCode + "/")
            .pipe(catchError(function (error) { return observableThrowError(error); }))
            .subscribe();
    };
    ResourceService.prototype.getLessonPlanContent = function (resourceCode) {
        // This method will be used from lesson plan layout component
        return this.lmApi
            .get("/api/v2/lesson_plan_html/" + resourceCode)
            .pipe(catchError(function (error) { return observableThrowError(error); }));
    };
    ResourceService.prototype.getOrCreateActivity = function (resourceCode) {
        return this.lmApi
            .get("/api/v2/activity_for_resource/" + resourceCode + "/")
            .pipe(catchError(function (error) { return observableThrowError(error); }));
    };
    ResourceService.prototype.getLocalStorageShareAssignModalKey = function () {
        return "shouldOpenShareAssignModal";
    };
    ResourceService.prototype.getGoogleClassroomSharableLink = function (resourceCode, isLoggedIn) {
        var resourceUrlToShareGoogleClass = "https://classroom.google.com/share?url=" + window.location;
        var googleClassWindow = window.open("", "_blank", "width=640, height=450,toolbar=no, scrollbars=yes");
        if (isLoggedIn) {
            // TODO: DON'T ADD this subscription to subscriptions to be deleted, since it does a post on activity
            // endpoint and we don't want to leave the it in an inconsistent state
            this.getOrCreateActivity(resourceCode).subscribe(function (activityData) {
                if (activityData.isAssignable) {
                    googleClassWindow.location.href =
                        "https://classroom.google.com/share?url=" +
                            activityData.activity.student_url +
                            "&title=" +
                            activityData.activity.name;
                }
                else {
                    googleClassWindow.location.href = resourceUrlToShareGoogleClass;
                }
            });
        }
        else {
            googleClassWindow.location.href = resourceUrlToShareGoogleClass;
        }
    };
    ResourceService.prototype.getAssetDownloadUrl = function (media) {
        return this.lmApi
            .get(media.downloadGenerateURL)
            .pipe(catchError(function (error) { return observableThrowError(error); }));
    };
    ResourceService.prototype.getLessonPlanExportUrl = function (resource) {
        return this.lmApi
            .get("/api/v2/lesson_plan_word/" + resource.resourceCode)
            .pipe(catchError(function (error) { return observableThrowError(error); }));
    };
    ResourceService.prototype.openSupportMaterialsTab = function () {
        this.goToSupportMaterials.emit(true);
    };
    ResourceService.prototype.cancelSubscriptions = function () {
        this.subscriptions.map(function (subscription) { return subscription.unsubscribe(); });
    };
    ResourceService.prototype.getResourceStandards = function (resourceCode) {
        var standardsURL = "/api/v2/lo/standards/r/" + resourceCode + "/";
        if (this.localizationService.hasOrganization()) {
            standardsURL += this.localizationService.getOrganizationId() + "/";
        }
        return this.lmApi
            .getWithCookiesInParams(standardsURL, ["logged_in"])
            .pipe(catchError(function (error) { return observableThrowError(error); }));
    };
    ResourceService.prototype.setStandardsInformation = function (resourceCode) {
        var _this = this;
        this.subscriptions.push(this.getResourceStandards(resourceCode).subscribe(function (resStandards) {
            if (_this.resourceResponse.getValue().resourceCode !=
                resourceCode) {
                return;
            }
            var standardsInfo = StandardsInformation.fromData(resStandards, resourceCode);
            _this.standardsResponse.next(standardsInfo);
        }));
    };
    ResourceService.prototype.downloadTranscript = function (media) {
        if (media.transcriptURL) {
            var win = window.open(media.transcriptURL, "_blank");
            win.focus();
        }
        else {
            var modalRef = this.modalService.open(TextDisplayModalComponent, {
                size: "lg",
                windowClass: "text-display-modal",
            });
            modalRef.componentInstance.text = media.transcriptText;
            modalRef.componentInstance.printURL = media.transcriptPrintURL;
        }
    };
    ResourceService.ngInjectableDef = i0.defineInjectable({ factory: function ResourceService_Factory() { return new ResourceService(i0.inject(i1.HttpClient), i0.inject(i2.LmApiService), i0.inject(i3.LocalizationService), i0.inject(i4.Router), i0.inject(i5.URSService), i0.inject(i6.NgbModal)); }, token: ResourceService, providedIn: "root" });
    return ResourceService;
}());
export { ResourceService };
